import { motion } from "framer-motion";
import { ShieldCheck, Users, Sparkles } from "lucide-react";

const STATS = [
  { icon: Sparkles, label: "One-Stop Shop", value: "Everyday Essentials" },
  { icon: Users, label: "Friendly Staff", value: "Expert Guidance" },
  { icon: ShieldCheck, label: "Trusted", value: "21+ Compliant" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm uppercase tracking-[0.25em] text-zinc-500">
            About Us
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight mt-4 leading-tight">
            Your one-stop convenience store, vape &amp; smoke shop in{" "}
            <span className="text-gradient">Maple Shade</span>
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            FILL N&apos; CHILL is your neighborhood convenience store, vape shop,
            and smoke shop on Route 38, proudly serving Maple Shade and Burlington
            County. Grab everyday essentials—snacks and chips, cold drinks and
            energy drinks, candy and chocolates—plus an on-site ATM, right
            alongside a premium selection of vape and smoke products.
          </p>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            From disposable vapes, pod systems, and vape juice to nicotine
            pouches, cigars and cigarettes, hookah products, kratom, and smoking
            accessories, we&apos;ve carefully curated the brands locals love—Geek
            Bar, RAZZ, Flair, Cali, Tyson, and more. Whether you&apos;re grabbing
            a quick snack or a specialty smoke product, our friendly team makes
            every visit fast, easy, and welcoming.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {STATS.map((s) => (
              <div
                key={s.label}
                data-testid={`about-stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                className="glass rounded-2xl p-4 md:p-5"
              >
                <s.icon className="text-[#00e5ff] mb-3" size={22} />
                <div className="text-xs text-zinc-500">{s.label}</div>
                <div className="text-sm font-medium text-white mt-1">
                  {s.value}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="absolute -inset-4 bg-gradient-to-tr from-[#00e5ff]/20 to-[#39ff14]/20 blur-3xl rounded-full opacity-40" />
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <img
              src="https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/v4713d7f_IMG_7501_1999px.jpg"
              alt="FILL N' CHILL storefront in Maple Shade NJ"
              className="w-full h-[460px] object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
